// Services.js
import '../../../assets/css/screens/customer/services/Services.css';
import Navbar from '../../../components/customer/home/Navbar/MyNavbar';
import Topbar from '../../../components/customer/home/topbar/Topbar';
import ServiceCard from '../../../components/customer/services/servicecards/ServiceCards';
import LoginModal from '../../../components/customer/auth/loginModal/LoginModal';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';


import React, { useState, useMemo, useEffect, useContext } from 'react';
import Swal from 'sweetalert2';

import {
  Search, Sparkles, Wrench, Zap, UtensilsCrossed, Paintbrush,
  Hammer, Wind, Scissors, Truck, Home, Droplet, HardHat,
  SlidersHorizontal, X
} from 'lucide-react';
import Myfooter from '../../../components/customer/home/footer/Myfooter';
import ScrollToTop from '../../general/scrolltotop/ScrollToTop';
import AppContext from '../../../context/AppContext';






const ICON_ROW = [
  { id: 'all', name: 'All', icon: Home },
  { id: 'cleaning', name: 'Cleaning', icon: Sparkles },
  { id: 'plumbing', name: 'Plumbing', icon: Wrench },
  { id: 'electrical', name: 'Electrical', icon: Zap },
  { id: 'cooking', name: 'Cooking', icon: UtensilsCrossed },
  { id: 'painting', name: 'Painting', icon: Paintbrush },
  { id: 'moving', name: 'Moving', icon: Truck },
];



/* ─── COMPONENT ─── */
const Services = () => {
 const {baseUrl, baseUrlForFile} = useContext(AppContext);
  const [heroSearch, setHeroSearch] = useState('');
  const [sidebarSearch, setSidebarSearch] = useState('');
  const [activeCategory, setActiveCategory] = useState('all');
  const [activeSubFilter, setActiveSubFilter] = useState('');
  const [expandedCat, setExpandedCat] = useState('cleaning');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const navigate = useNavigate();
  const searchTerm = heroSearch || sidebarSearch;
  // add state for category 
  const [categories, setCategories] = useState([]);






  // fetch category from backend

 useEffect(() => {
  axios.get(`${baseUrl}/user/viewcategory`)
    .then((response) => {
      const activeCategories = response.data.categories; // 👈 change here

      const formattedCategories = activeCategories.map((cat) => ({
        id: cat.id,
        name: cat.categoryName,
        image: `${baseUrlForFile}/${cat.categoryImage}`,
        description: cat.description,
      }));

      setCategories(formattedCategories);
    })
    .catch((error) => {
      console.log("Category fetch error:", error);
    });
}, []);



  const filteredCategories = categories.filter(cat => {
    const searchMatch =
      !searchTerm ||
      cat.name.toLowerCase().includes(searchTerm.toLowerCase());

    const categoryMatch =
      activeCategory === 'all' || cat.id === activeCategory;

    return searchMatch && categoryMatch;
  });
  // 🔥 LOGIN CHECK FUNCTION
  const handleServiceClick = (service) => {
    const isLoggedIn = localStorage.getItem("isLoggedIn");

    if (!isLoggedIn) {
      Swal.fire({
        icon: 'warning',
        title: 'Login Required',
        text: 'Please login first to access this service.',
        confirmButtonText: 'Login Now',
        confirmButtonColor: '#0491e1',
        background: '#ffffff',
        color: '#484745'
      }).then((result) => {
        if (result.isConfirmed) {
          setShowLoginModal(true); // 🔥 open login modal
        }
      });
      return;
    }

    // ✅ If logged in
    console.log("Access granted to:", service.name);
  };



  const clearFilters = () => {
    setActiveCategory('all');
    setActiveSubFilter('');
    setHeroSearch('');
    setSidebarSearch('');
  };

  const handleLoginSuccess = () => {
    setShowLoginModal(false); // modal close on login
    Swal.fire({
      icon: 'success',
      title: 'Logged in!',
      timer: 1200,
      showConfirmButton: false,
      background: '#ffffff',
      color: '#484745'
    });
  };

  return (
    <>
      {/* <ScrollToTop /> */}
      <Topbar />
      <Navbar />

      <div className="sp-root">

        <div className="sp-page-heading">
          <h1 className="sp-services-title">Our Category</h1>
          <p className="sp-services-sub">Find trusted professionals for every home need</p>
        </div>

        <section className="sp-body">

          {sidebarOpen && (
            <div className="sp-sidebar-overlay" onClick={() => setSidebarOpen(false)} />
          )}

          <button className="sp-mobile-filter-btn" onClick={() => setSidebarOpen(p => !p)}>
            <SlidersHorizontal size={16} />
            {sidebarOpen ? 'Hide Filters' : 'Show Filters'}
          </button>

          {/* SIDEBAR */}
          <aside className={`sp-sidebar${sidebarOpen ? ' sp-sidebar--open' : ''}`}>
            <div className="sp-sidebar__header">
              <span className="sp-sidebar__header-title">
                <SlidersHorizontal size={15} /> Filters
              </span>
              <button className="sp-sidebar__close" onClick={() => setSidebarOpen(false)}>
                <X size={18} />
              </button>
            </div>

            <div className="sp-sidebar__section-title">
              Browse by Category
            </div>

            <div className="sp-sidebar__cats">

              {/* call category  */}
              {categories.map(cat => {
                return (
                  <div key={cat.id} className="sp-sidebar__cat">
                    <button
                      className={`sp-sidebar__cat-btn${activeCategory === cat.id ? ' sp-sidebar__cat-btn--active' : ''}`}
                      onClick={() => {
                        setExpandedCat(cat.id);
                        setActiveCategory(cat.id);
                        setActiveSubFilter('');
                      }}
                    >
                      <span className="sp-sidebar__cat-left">
                        {cat.name}

                      </span>
                    </button>
                  </div>
                );
              })}
            </div>

            <button className="sp-sidebar__reset" onClick={clearFilters}>
              <X size={14} /> Clear All Filters
            </button>
          </aside>

          {/* GRID */}
          <main className="sp-main">
            {filteredCategories.length === 0 ? (
              <div className="sp-empty">
                <Search size={48} />
                <p>No services found.</p>
                <button onClick={clearFilters}>Clear Filters</button>
              </div>
            ) : (
              <div className="sp-grid">
                {filteredCategories.map((cat, idx) => (
                  <ServiceCard
                    key={cat.id}
                    item={cat}
                    index={idx}
                    onClick={handleServiceClick}
                  />
                ))}
              </div>
            )}
          </main>
        </section>
      </div>

      {/* LOGIN MODAL */}
      {showLoginModal && (
        <LoginModal
          isOpen={showLoginModal}
          onClose={() => setShowLoginModal(false)}
          onLoginSuccess={handleLoginSuccess}
        />
      )}

      <Myfooter />
    </>
  );
};

export default Services;